import {
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgProgress } from '@ngx-progressbar/core';
import { ToastrService } from 'ngx-toastr';
import 'rxjs/add/operator/map';
import { APIOperableComponent } from '../../../../shared/components/api-operable/api-operable.component';
import { IssueService } from '../../../issue/service/issue.service';
import { AuthService } from '../../../security/service/auth.service';
import { IssueRelatedQuestionModel } from '../../model/issue.related.question.model';
import { QuestionUIMessages } from '../../model/question-ui.messages';
import { QuestionModel } from '../../model/question.model';
import { QuestionChoiceModel } from '../../model/questionChoice.model';
import { QuestionService } from '../../service/question.service';
import { EditQuestionChoiceComponent } from '../edit-question-choice/edit-question-choice.component';
import moment = require('moment');
@Component({
  selector: 'question-list',
  templateUrl:
    'console/app-js/modules/question/components/question-list/question-list.component.html',
  encapsulation: ViewEncapsulation.None
})
export class QuestionListComponent extends APIOperableComponent
  implements OnInit, OnDestroy {
  public issueId: string;
  protected questionData: IssueRelatedQuestionModel = new IssueRelatedQuestionModel();
  protected cancelQuestionData: IssueRelatedQuestionModel;
  protected activeQuestionData: QuestionModel[];
  public pageLoading = false;
  public date;
  protected selectedQuestion: QuestionModel;
  public questionId: string;
  public editOpen = false;
  public addNew = false;
  protected showQuestionTypes: Boolean = false;
  public element: QuestionModel;
  protected firstElementId: string;
  protected lastElementId: string;
  protected orderByField = 'orderIndex';
  protected selectedCustomer: string;
  protected priorities: any;
  @ViewChild('EditQuestionChoiceComponent', { static: false })
  editQuestionChoiceComponent: EditQuestionChoiceComponent;
  constructor(
    private activatedRoute: ActivatedRoute,
    private questionService: QuestionService,
    protected progressService: NgProgress,
    protected toastr: ToastrService,
    protected authService: AuthService,
    protected issueService: IssueService,
    private router: Router
  ) {
    super(progressService, toastr, authService);
    this.issueId = this.activatedRoute.snapshot.params['issueId'];
  }

  @HostListener('window:beforeunload')
  canDeactivate(): boolean {
    if (
      this.editQuestionChoiceComponent !== undefined ||
      this.showQuestionTypes
    ) {
      return false;
    } else {
      return true;
    }
  }

  ngOnInit(): void {
    const d = new Date();
    this.date = moment(d).toString();
    this.getIssueQuestions();
    this.questionId = null;
    // Keep aside a cancel rollback variable
    this.cancelQuestionData = this.questionData;
    this.selectedCustomer = localStorage.getItem('cNum');
    this.priorities = [];
    this.questionService.getCustomerPriorities().subscribe(res => {
      res.results.forEach(priority => {
        this.priorities.push({ id: priority.name, value: priority.name });
      });
    });
  }

  /**
   * Lifecycle hook
   */
  ngOnDestroy() {
    this.cancelQuestionData = null;
  }
  /**
   * Method to get questions on the issue level
   */
  protected getIssueQuestions(): void {
    this.pageLoading = true;
    this.questionService.getQuestions(this.issueId).subscribe(
      (res: any) => {
        if (res.elements) {
          if (res.elements.length !== 0) {
            const results = res.elements.map(question => {
              return {
                id: question.id,
                text: question.text,
                elementType: question.elementType,
                isActive: question.isActive,
                formElementChoices: question.choices,
                orderIndex: question.orderIndex
              };
            });
            this.activeQuestionData = results.filter(result => result.isActive);
            this.setBoundaryElements();
            this.questionData.elements = results;
          }
          this.questionData.type = 'Gather Data';
          this.questionData.id = res.id;
          this.questionData.elementType = 'Page';
          this.questionData.issueId = res.issueId;
          this.questionData.isActive = true;
        } else {
          this.onAPIError(QuestionUIMessages.LOAD_QUESTION_ERROR);
          this.pageLoading = false;
        }
        this.pageLoading = false;
      },
      () => {
        this.onAPIError(QuestionUIMessages.LOAD_QUESTION_ERROR);
        this.pageLoading = false;
      }
    );
  }

  /**
   * Method to set boundary elements
   */
  setBoundaryElements(): void {
    if (this.activeQuestionData.length > 0) {
      let indices: any = this.reFreshBoundaryElementIndices(
        this.activeQuestionData
      );
      this.firstElementId = indices.firstElem;
      this.lastElementId = indices.lastElem;
    }
  }

  /**
   * Method to refrsh boundary element indices
   * @param none
   */
  reFreshBoundaryElementIndices(reIndexedOrder: QuestionModel[]): Object {
    let reOrderedElements = [];
    reOrderedElements = reIndexedOrder.sort(
      (b, a) => b.orderIndex - a.orderIndex
    );
    let firstElementId = reOrderedElements[0].id;
    let lastElementId = reOrderedElements[reOrderedElements.length - 1].id;
    return {
      elements: reOrderedElements,
      firstElem: firstElementId,
      lastElem: lastElementId
    };
  }

  /**
   * Method to show and hide question in edit mode
   */
  showQuestion(questionId: string): void {
    this.questionId = questionId;
    this.editOpen = true;
    const found = this.activeQuestionData.find(ques => {
      return ques.id.toString().includes('Custom_ID') && ques.id !== questionId;
    });
    if (found) {
      const index: number = this.activeQuestionData.indexOf(found);
      this.activeQuestionData.splice(index, 1);
    }
    // reset the first and last elements
    this.setBoundaryElements();
  }

  onClose(event: any): void {
    if (event.action === 'Save' || event.action === 'Update') {
      this.router.navigate([`/console/issue/${this.issueId}/question`]);
    } else if (event.action === 'Delete') {
      this.editOpen = false;
      const foundQues = this.activeQuestionData.find(ques => {
        return ques.id === event.question.id;
      });
      if (foundQues) {
        foundQues.isActive = false;
      }
      const index = this.activeQuestionData.findIndex(
        question => question.id === event.question.id
      );
      this.activeQuestionData.splice(index, 1);
    } else if (event.action === 'Cancel') {
      this.editOpen = false;
      // this.questionData = this.cancelQuestionData;
      // Take the one-to-one moving of initial object to activeQuestionData
      this.cancelQuestionData.elements.forEach(elem => {
        this.activeQuestionData.forEach(orig => {
          if (elem.id === orig.id) {
            Object.assign(orig, elem);
          }
        });
      });
      this.questionId = null;
      this.activeQuestionData = event.reIndexedElements;
      this.firstElementId = event.firstElement;
      this.lastElementId = event.lastElement;
      this.setBoundaryElements();
      this.addNew = false;
    }
  }

  /**
   * Method to show and hide add question types
   */
  addQuestion(): void {
    if (this.showQuestionTypes) {
      this.showQuestionTypes = false;
    } else {
      this.showQuestionTypes = true;
    }
  }

  /**
   * Method to choose different types of question
   */
  chooseQuestionType(elementType: string): void {
    this.addNew = true;
    switch (elementType) {
      case 'radio':
        this.addDynamicQuestionType('RadioButtonList');
        break;
      case 'checkbox':
        this.addDynamicQuestionType('CheckboxList');
        break;
      case 'numeric':
        this.addDynamicQuestionType('IntegerInput');
        break;
      case 'date':
        this.addDynamicQuestionType('DateInput');
        break;
    }
  }

  /**
   * Method to add dynamic question types
   */
  addDynamicQuestionType(type: string): void {
    if (!this.activeQuestionData) {
      this.activeQuestionData = [];
    }
    this.element = new QuestionModel();
    const id = Math.floor(Math.random() * 600) + 1;
    this.element.id = id + 'Custom_ID';
    this.lastElementId = this.element.id;
    if (type === 'RadioButtonList' || type === 'CheckboxList') {
      this.element.formElementChoices = Array(
        new QuestionChoiceModel(id + 'Custom_ID'),
        new QuestionChoiceModel(id + 1 + 'Custom_ID')
      );
    }
    this.element.elementType = type;
    this.element.isActive = true;
    this.element.orderIndex = this.questionData.elements.length + 1;
    this.activeQuestionData.push(this.element);
    this.showQuestionTypes = false;
    this.showQuestion(this.element.id);
  }

  /**
   * Method to handle re-order of activeQuestionData array
   */
  onReorder(value: any): void {
    this.activeQuestionData = value.reIndexedElements;
    this.firstElementId = value.firstElement;
    this.lastElementId = value.lastElement;
  }
}
